// Error.js
import React, { useContext } from "react";
import { ThemeContext } from "../logic/themeContext";
import "../style/error.css";
import { ReactComponent as CompassBlack } from "../mediaSvg/compassBlack.svg";
import { ReactComponent as CompassWhite } from "../mediaSvg/compassWhite.svg";

function Error({ cityError }) {
  const { theme } = useContext(ThemeContext);

  return (
    <div className="errorContainer">
      <div className="leftContent">
        {theme === "dark" ? (
          <CompassWhite className="compassRing" />
        ) : (
          <CompassBlack className="compassRing" />
        )}
        <div className="compassContainer">
          <div className="sudArrow">
            <p>S</p>
          </div>
          <div translate="no" className="northArrow">
            <p>N</p>
          </div>
        </div>
      </div>
      <div className="rightContent">
        <div className="test">
          <p className="cityErrorGeneral">Sorry, the city of</p>
          <p className="cityError">{cityError}</p>
          <p className="cityErrorGeneral">was not found.</p>
        </div>
      </div>
    </div>
  );
}

export default Error;
